function catalogPublicLandingOrigin() {
  const apiUrl = (process.env.REACT_APP_API_URL || '').trim().replace(/\/$/, '');
  if (apiUrl) {
    try {
      return new URL(apiUrl).origin;
    } catch {
      return apiUrl;
    }
  }
  return typeof window !== 'undefined' ? window.location.origin : '';
}

export async function catalogPublicSlug(catalogId) {
  const catalog = String(catalogId || '').trim();
  if (!catalog) return '';
  const data = new TextEncoder().encode(catalog);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('');
}

export async function buildCatalogPublicLandingUrl(workspaceId, catalogId) {
  const workspace = String(workspaceId || '').trim();
  const slug = await catalogPublicSlug(catalogId);
  if (!workspace || !slug) return '';
  const origin = typeof window !== 'undefined' ? window.location.origin : catalogPublicLandingOrigin();
  return `${origin}/catalog/landing-page/${encodeURIComponent(workspace)}/${encodeURIComponent(slug)}`;
}
